import styled from 'styled-components';

import { ArrowDirectionButton } from '../../../../../components/inputs/buttons/ArrowDirectionButton';

// Components
import { SpecialTag } from '../../../../../components/display/SpecialTag';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xxl};
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const ArrowRadioGroup = styled(ArrowDirectionButton)``;

export const ContainerSpecialTag = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -5rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0;
  }
`;

export const DuplicateTag = styled(SpecialTag)`
  cursor: pointer;
  z-index: 1;
`;
